import { HouseOwnerHouseFieldFragment, OwnerSpaceModeEnum } from '@/lib/graphql'

import { getOwnerSpaceModePermission } from '@/utils/permissionPage'

type PermissionResult = {
  granted: boolean
  redirectUrl?: string
  showCustom404?: boolean
}

export const getPermissionAccessPage = ({
  house,
  permission,
}: {
  house: HouseOwnerHouseFieldFragment | undefined
  permission: OwnerSpaceModeEnum
}): PermissionResult => {
  if (house) {
    const hasPermission = getOwnerSpaceModePermission({
      requiredPermission: permission,
      userPermission: house?.ownerSpaceMode,
    })

    if (!hasPermission) {
      if (house?.ownerSpaceMode === OwnerSpaceModeEnum.PREVIEW) {
        return { granted: false, showCustom404: true }
      } else {
        return { granted: false, redirectUrl: '/bookings' }
      }
    }
  }
  return { granted: true }
}
